import React from 'react';
import { ChangeHighlighter, FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
export const createFinancialDetailBreakdownTableData = (costCalculations, t, columnWidth) => {
  const headers = ['resume_of_cost', ...costCalculations.breakdowns].map(heading => {
    return {
      text: typeof heading === 'string' ? t(heading) : String(heading.year),
      sortable: false,
      width: columnWidth + 'px'
    };
  });
  const breakdowns = costCalculations.breakdowns;
  const years = breakdowns.map(b => b.year); // [2025, 2026, etc.]

  // 2. Collect all unique cost items (financial_detail_name)
  const allItems = []; // ['offer 1', 'estimate 2', etc. ]

  breakdowns.forEach(b => {
    b.costs.forEach(c => {
      const name = c.financial_detail_name || c.cost_type;
      const costType = c.cost_type;
      if (!allItems.find(item => item.name === name && item.costType === costType)) {
        allItems.push({
          name,
          costType
        });
      }
    });
  });

  // Sort by costType: 'offer' first, 'estimate' last
  allItems.sort((a, b) => {
    if (a.costType === 'offer' && b.costType !== 'offer') return -1;
    if (a.costType !== 'offer' && b.costType === 'offer') return 1;
    return 0;
  });

  // 3. Build rows for table.
  const rows = allItems.map(item => {
    const columns = [item.name];
    years.forEach(year => {
      // Find the matching cost entry for this item & year
      const yearData = breakdowns.find(b => b.year === year);
      const cost = yearData === null || yearData === void 0 ? void 0 : yearData.costs.find(c => c.financial_detail_name === item.name && c.cost_type === item.costType);
      const costTotal = cost ? cost.total : 0;
      const costTotalFormatter = /*#__PURE__*/React.createElement(ChangeHighlighter, {
        as: FormattedNumberInput,
        thousandSeparator: ".",
        decimalSeparator: ",",
        object: {
          costTotal
        },
        name: "costTotal",
        type: "text",
        size: "sm",
        disabled: true
      });
      columns.push(costTotalFormatter);
    });
    return {
      columns
    };
  });
  const totalRow = {
    columns: [t('total'), ...costCalculations.total_per_year.map(y => {
      return /*#__PURE__*/React.createElement(ChangeHighlighter, {
        as: FormattedNumberInput,
        thousandSeparator: ".",
        decimalSeparator: ",",
        object: y,
        name: "total",
        type: "text",
        size: "sm",
        disabled: true
      });
    })]
  };
  return {
    headers,
    rows: [...rows, totalRow]
  };
};